import React, { Component, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as router from "react-router-dom";
import { Container } from "reactstrap";
import Spinner from "../../../src/spinner/index"
import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav,
} from "@coreui/react";
// sidebar nav config
import navigation from "../../_nav";
import langNav from "../../langNav";
// routes config
import routes from "../../routes";
import "../../screens/common/common.css";
import { connect } from "react-redux";
import Axios from "axios";
// import {getVersion} from "../../AppVersion";
import Cookies from "js-cookie";
import { getVersion, getDotLiveProductionVersion, getUsVersion, getAEVersion } from '../../AppVersion'
import { getVersionStaging, getDotLiveVersionStaging } from '../../AppVersionStaging'
import { configuration } from '../../appConfig';
import Swal from "sweetalert2";

const DefaultAside = React.lazy(() => import("./DefaultAside"));
const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class DefaultLayout extends Component {
  state = {
    words: {},
    lang: "de",
    routes: [],
    navRoutes: langNav.items,
    fallbackDetail : {}, 
    loading: false,
    appVersion: '',
    mobileappVersion: '',
    damageVinList : []
  };
  totalLang = [
    "gb",
    "de",
    "fr",
    "si",
    "ch",
    "cz",
    "ro",
    "nl",
    "us",
    "au",
    "it",
    "sp",
    "at",
    "ku",
    "fr-fr",
    "fr-ch",
    "pl",
    "us-en",
  ];
  logout = () => {
    window.localStorage.clear();
    this.props.history.push("/login");
    window.location.reload();
  };
  componentDidMount() {
    this.getFallbackDetails();
    this.getLang();
    this.fetchVersion();
    const partnerId = localStorage.getItem("partnerId");
    window.localStorage.getItem("partner_partnerId") === localStorage.getItem("partnerId") ? this.getLang() : this.logout();
    if (partnerId == "501-240515" || partnerId == "500-210601" || partnerId == "502-240515" || partnerId == "503-240501") {
      setInterval(() => {
        this.getDamagesVin();
      }, 5000);
    }
  }
  getFallbackDetails = async()=>{
    this.setState({loading : true})
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    const res = await Axios.get(url);
    if (res.data.success !== false) {
      this.setState({
        fallbackDetail : res.data,
        loading : false 
      });
      const rollID = res.data.role_id == 1 ? res.data.role_id : 2
      localStorage.setItem("PartnerRollID", rollID)
    } else{
      this.setState({
        loading : false
      });
    }
  }

  componentDidUpdate(prevState) {
    if (prevState.lang !== this.state.lang) {
      let changedRoutes = navigation.items.map((route, index) => {
        route.name = this.lang(this.state.navRoutes[index].name);
        return route;
      });
      this.setState({
        routes: changedRoutes,
      });
    }
  }

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      let changedRoutes = navigation && navigation.items && navigation.items.map((route, index) => {
        route.name = res && res.data[this.state.navRoutes[index].name][lang];
        return route;
      });
      this.setState({
        words: res.data,
        routes: changedRoutes,
      });

      if (!this.totalLang.includes(lang)) {
        localStorage.setItem("lang", "de");
        this.setState({ lang: "de" });
        this.props.changeLang("de");
      } else {
        this.setState({ lang: lang });
        this.props.changeLang(lang);
      }
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;

    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  signOut(e) {
    e.preventDefault();
    localStorage.clear();
    this.props.history.push("/login");
    Cookies.remove("cookieSetDate")
    Cookies.remove("cookieSetDateDashboard")
    Cookies.remove("jumpPage")
    Cookies.remove("filterDate")
    Cookies.remove("authorizeFilter")
    Cookies.remove("recordsPerPage")
    Cookies.remove("dateChanged")
    Cookies.remove("location")
    Cookies.remove("cookieSetDateQR")
    Cookies.remove("QRjumpPage")
    Cookies.remove("filterQRDate")
    Cookies.remove("QRdateChanged")

    Cookies.remove("rememberInsuranceManagementDate")
    Cookies.remove("rememberInsuranceManagement")
    Cookies.remove("rememberEmailAuthorized")
    Cookies.remove("rememberDatCredentialDate")
    Cookies.remove("rememberDatCredential")
    Cookies.remove("rememberEmailAuthorizedDate")
    window.location.reload();

  }

  fetchVersion = async () => {
    const versionStag = await getVersionStaging();
    const DotLiveVersionStag = await getDotLiveVersionStaging();
    const versionProd = await getVersion();
    const DotLiveVersionProd = await getDotLiveProductionVersion();
    const USVersionProd = await getUsVersion();
    const AEVersionProd = await getAEVersion();
    const currentOrigin = window.location.origin.replace(/\/$/, "");
    
    try {
      let Payload = "";
      
      // Determine the Payload based on currentOrigin
      if (currentOrigin == "http://localhost:3000") {
        Payload = { app_type: "web_app" };
      } else if (currentOrigin == "http://general-damage.driveandscan.com" || currentOrigin == "http://www.general-damage.driveandscan.com") {
        Payload = { app_type: "live_app" };
      } else if (currentOrigin == "https://www.driveandscan.com" || currentOrigin == "https://driveandscan.com") {
        Payload = { app_type: "web_app" };
      } else if (currentOrigin == "https://drivenscan.app" || currentOrigin == "https://www.drivenscan.app") {
        Payload = { app_type: "web_app" };
      } else if (currentOrigin == "https://drivenscan.live" || currentOrigin == "https://www.drivenscan.live") {
        Payload = { app_type: "live_app" };
      } else if (currentOrigin == "https://drivenscan.us" || currentOrigin == "https://www.drivenscan.us") {
        Payload = { app_type: "us_app" };
      } else if (currentOrigin == "https://drivenscan.ae" || currentOrigin == "https://www.drivenscan.ae") {
        Payload = { app_type: "ae_app" };
      } else {
        Payload = { app_type: "web_app" };
      }
  
        const URL = configuration.getVersion;
        try {
          const res = await Axios.post(URL, Payload);
  
          if (res.data.success) {
            this.setState({
              appVersion: res.data.data.web_app,
              mobileappVersion: res.data.data.mobile_app
            }, () => {
              const { appVersion } = this.state;
  
              // Check conditions and call AddVersionStaging/AddVersionProduction accordingly
              if (currentOrigin == "http://localhost:3000" && appVersion != versionStag) {
                this.AddVersionStaging("web_app");
              } else if ((currentOrigin == "http://general-damage.driveandscan.com" || currentOrigin == "http://www.general-damage.driveandscan.com") && appVersion != DotLiveVersionStag) {
                this.AddVersionStaging("live_app");
              } else if ((currentOrigin == "https://www.driveandscan.com" || currentOrigin == "https://driveandscan.com") && appVersion != versionStag) {
                this.AddVersionStaging("web_app");
              } else if ((currentOrigin == "https://drivenscan.app" || currentOrigin == "https://www.drivenscan.app") && appVersion != versionProd) {
                this.AddVersionProduction("web_app");
              } else if ((currentOrigin == "https://drivenscan.live" || currentOrigin == "https://www.drivenscan.live") && appVersion != DotLiveVersionProd) {
                this.AddVersionProduction("live_app");
              } else if ((currentOrigin == "https://drivenscan.us" || currentOrigin == "https://www.drivenscan.us") && appVersion != USVersionProd) {
                this.AddVersionProduction("us_app");
              } else if ((currentOrigin == "https://drivenscan.ae" || currentOrigin == "https://www.drivenscan.ae") && appVersion != AEVersionProd) {
                this.AddVersionProduction("ae_app");
              }
            });
          }
        } catch (error) {
          console.error('Error fetching version:', error);
        }
  
    } catch (error) {
      console.error('Error setting payload:', error);
    }
  };
  
  AddVersionStaging = async (type) => {
    try {
      const {mobileappVersion} = this.state;
      const version = await getVersionStaging();
      const DotLiveVersionStag = await getDotLiveVersionStaging();
      const URL = configuration.addVersion;
      const Payload =
      {
        app_type: type,
        web_app: type == 'web_app' ? version : DotLiveVersionStag,
        mobile_app: mobileappVersion
      }

    const res = await Axios.post(URL, Payload)
    if(res.data.success == true){
      const {appVersion} = this.state;
      if(appVersion != version){
        this.fetchVersion()
      } 
      // if (appVersion != DotLiveVersionStag){
      //   this.fetchVersion()
      // }
    }

    } catch (error) {
      console.error('Error fetching version:', error);
    }
  };
  
  AddVersionProduction = async (type) => {
    try {
      const {mobileappVersion} = this.state;

      const version = await  getVersion();
      const DotLiveVersionProd = await getDotLiveProductionVersion();
      const USVersionProd = await getUsVersion()
      const AEVersionProd = await getAEVersion()
      const currentOrigin = window.location.origin.replace(/\/$/, "");

      const versionType = type == 'web_app' ? version : type == 'live_app' ? DotLiveVersionProd : type == 'us_app' ? USVersionProd : type == 'ae_app' ? AEVersionProd : version;
      const URL = configuration.addVersion;
      const Payload =
      {
        app_type: type,
        web_app: versionType,
        mobile_app: mobileappVersion
      }

    const res = await Axios.post(URL, Payload)
    if(res.data.success == true){
      const {appVersion} = this.state;
      if((currentOrigin == "https://drivenscan.app" || currentOrigin == "https://www.drivenscan.app") && appVersion != version){
        this.AddVersionStaging()
      }
      if((currentOrigin == "https://drivenscan.live" || currentOrigin == "https://www.drivenscan.live") && appVersion != DotLiveVersionProd){
        this.AddVersionStaging()
      }
      if((currentOrigin == "https://drivenscan.us" || currentOrigin == "https://www.drivenscan.us") && appVersion != USVersionProd){
        this.AddVersionStaging()
      }
      if((currentOrigin == "https://drivenscan.ae" || currentOrigin == "https://www.drivenscan.ae") && appVersion != AEVersionProd){
        this.AddVersionStaging()
      }
    }

    } catch (error) {
      console.error('Error fetching version:', error);
    }
  };

  getDamagesVin = async ()=>{
    const partnerId = localStorage.getItem("partnerId")
    const url = `${configuration.getDamagesVin}?partner_id=${partnerId}`
    await Axios.get(url).then((res)=>{
      if (res.data && res.data.success == true) {
        // if (res.data.data.list.length == 1) {
        //   Swal.fire(this.lang("Below vin is completed"),res.data.data.list[0],  "success");
        // }
        if (res.data.data.list.length > 0) { 
          const damageVinListString = res.data.data.list.join(", ");
          Swal.fire(this.lang("Below vin is completed"),damageVinListString,  "success");
        }
        this.setState({
          damageVinList : res.data.data.list
        })
      } else {
        this.setState({
          damageVinList : []
        })
      }
    }).catch((err)=>{
        console.error(err)
    })
  }

  render() {
    const { appVersion, mobileappVersion,fallbackDetail,loading } = this.state
    const partnerId = localStorage.getItem("partnerId")
    const { location } = this.props;
    const notShowReport = [
      '/qrlist', '/createQR', '/AllScanRecords', '/Statistics', '/UserCreation', '/dashboard', '/profile', '/ScanList', '/UpdateLang', '/Notes', '/vehicleDentInfo3DNew', '/mobileUser', '/emailAuthorized','/datCredentials','/insuranceManagement'
    ];
    const hasVIN = localStorage.getItem('selectedFile') !== null;
    const addClass = notShowReport.includes(location.pathname) ? 'dashboard-main-wrapper' : '';
    var navigationRoot = this.state.routes;

    // if(this.state.lang=="De"){
    // let navigation2 = navigationRoot.map((route)=>{
    //   route.name=this.lang(route.name)
    //   return route
    // })
    // }
    let navigation1 = {
      items: navigationRoot,
    };
    // if(this.state.lang==="En"){
    //   navigation1={
    //     items:this.state.routes
    //   }
    // }
    let  filteredRoutes = Object.keys(fallbackDetail).length > 0 && routes.filter(route => {
      if (route.path === '/UserCreation' || route.path === '/mobileUser') {
        return partnerId === '002-sa';
      }
      if (route.path === '/insuranceManagement') {
        return fallbackDetail.is_show_insurance == 1;
      }
      if (route.path === '/emailAuthorized') {
        return fallbackDetail.is_email_authorized == 1;
      }
      if (route.path === '/datCredentials') {
        return fallbackDetail.is_dat == 1;
      }
      return true;
    });

    return (
      <>
      {
        loading ?
        "" :
      <div className="app">
        <AppHeader fixed>
          <Suspense fallback={this.loading()}>
            <DefaultHeader onLogout={(e) => this.signOut(e)} />
          </Suspense>
        </AppHeader>
        <div className={`app-body ${addClass}`}>
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <Suspense>
              <AppSidebarNav
                navConfig={navigation1}
                {...this.props}
                router={router}
              />
            </Suspense>
            <AppSidebarFooter>
              <>
                <div className="sidebar_bottom_text_footer">
                  {/* <p className='text-center'><b>{this.lang("Version")}: {appVersion}</b></p> */}
                  <p className='text-left mb-0'><b>{this.lang("WebApp")}:</b> {appVersion}</p>
                  <p className='text-left mb-0'><b>{this.lang("MobileApp")}:</b> {mobileappVersion}</p>
                </div>
              </>
            </AppSidebarFooter>
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main">
            {/* <AppBreadcrumb appRoutes={routes} router={router}/> */}
            <Container fluid className="main_container_wrapper_app">
              <Suspense fallback={this.loading()}>
                <Switch>
                {
  Object.keys(fallbackDetail).length > 0 ? (
    filteredRoutes.map((route, idx) => {
      return route.component ? (
        <Route
          key={idx}
          path={route.path}
          exact={route.exact}
          name={route.name}
          render={(props) => (
            <route.component
              {...props}
              lang={this.props.lang}
            />
          )}
        />
      ) : null;
    })
  ) : (
    <div></div> // Or any other loading indicator/component
  )
}


                  <Redirect from="/" to="/login" />
                </Switch>
              </Suspense>
            </Container>
          </main>
          <AppAside fixed>
            <Suspense fallback={this.loading()}>
              <DefaultAside />
            </Suspense>
          </AppAside>
        </div>
        <AppFooter>
          <Suspense fallback={this.loading()}>
            <DefaultFooter />
          </Suspense>
        </AppFooter>
      </div>
      }
      </>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
const mapDispatchtoProps = (dispatch) => {
  return {
    changeLang: (val) => {
      dispatch({ type: "CHANGE_lANG", payload: val });
    },
  };
};
export default connect(mapStateToProps, mapDispatchtoProps)(DefaultLayout);
//export default DefaultLayout;
